<template>
  <div
    class="product-access-required rounded-xl p-5 cursor-pointer transition-all duration-200"
    @click="goToBilling"
  >
    <div class="flex items-start">
      <div class="icon-wrap mr-4">
        <i :class="productIcon"></i>
      </div>

      <div class="flex-1">
        <div class="flex items-center flex-wrap mb-2">
          <h3 class="text-base font-bold mr-2">
            {{ resolvedTitle }}
          </h3>

          <span class="product-badge">
            {{ productName }}
          </span>
        </div>

        <p class="text-sm text-gray-600 mb-4">
          {{ resolvedMessage }}
        </p>

        <div class="flex items-center text-sm font-semibold cta-text">
          <span>Go to Billing</span>
          <i class="mdi mdi-arrow-right ml-2"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductAccessRequired',

  props: {
    product: {
      type: String,
      required: true,
      validator(value) {
        return ['lsa_command', 'convertly'].includes(value)
      }
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    billingRoute: {
      type: String,
      default: '/billing-settings'
    }
  },

  computed: {
    productName() {
      if (this.product === 'lsa_command') return 'LSA Command'
      if (this.product === 'convertly') return 'Convertly'
      return 'Product'
    },

    productPrice() {
      if (this.product === 'lsa_command') return '$50/month'
      if (this.product === 'convertly') return '$250/month'
      return ''
    },

    productIcon() {
      if (this.product === 'lsa_command') return 'mdi mdi-chart-line'
      if (this.product === 'convertly') return 'mdi mdi-robot-outline'
      return 'mdi mdi-lock-outline'
    },

    resolvedTitle() {
      if (this.title) return this.title
      return `${this.productName} Required`
    },

    resolvedMessage() {
      if (this.message) return this.message

      if (this.product === 'lsa_command') {
        return `This section is part of LSA Command. Enable it in Billing to access LSA stats, leads, reports, and survey tools for ${this.productPrice}.`
      }

      if (this.product === 'convertly') {
        return `This section is part of Convertly. Enable it in Billing to access AI calls, SMS, and web chat tools for ${this.productPrice}.`
      }

      return 'This feature requires an enabled product.'
    }
  },

  methods: {
    goToBilling() {
      this.$router.push(this.billingRoute)
    }
  }
}
</script>

<style scoped>
.product-access-required {
  border: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
}

.product-access-required:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 35px rgba(15, 23, 42, 0.12);
  border-color: #cbd5e1;
}

.icon-wrap {
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.25);
}

.product-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
}

.cta-text {
  color: #2563eb;
}
</style>